import { getState } from './storage.js'

function loadFromCache (store) {
  if (store.state.initialized) {
    return Promise.resolve()
  }
  return getState()
    .then(state => {
      return store.commit('loadFromCache', state)
    })
}

function loggedInWithToken (store) {
  let params = new URLSearchParams(location.search)
  let token = params.get('token')
  if (token) {
    let a = store.dispatch('storeToken', token)
    window.history.replaceState({}, document.title, '/')
    return a
  }
  return Promise.resolve()
}

function initApp (store, next) {
  if (store.state.initialized) {
    return next()
  }
  if (window.location.search.indexOf('?token=') !== -1) {
    return loggedInWithToken(store)
      .then(() => loadFromCache(store))
      .then(() => next({ path: '/settings/' }))
      .then(() => store.dispatch('sync'))
      .then(() => store.dispatch('updateFromRemote'))
  }
  return loadFromCache(store)
    .then(() => next())
    .then(() => store.dispatch('sync'))
    .then(() => store.dispatch('updateFromRemote'))
}

export default initApp
